import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class CustomTitleStrategy extends TitleStrategy {
  private readonly baseTitle = 'SAD - Six Affective Dimensions';

  constructor(private readonly title: Title) {
    super();
  }

  override updateTitle(routerState: RouterStateSnapshot): void {
    const title = this.buildTitle(routerState);
    
    if (title) {
      this.title.setTitle(`${title} | ${this.baseTitle}`);
    } else {
      this.title.setTitle(this.baseTitle);
    }
  }
}
